<template>
  <table class="table  table-nowrap  table-hover align-middle">
    <thead class="text-muted table-light">
    <tr>
      <th scope="col" style="width: 25px" v-perm="'device.qrcode.bind'" v-if="showCheckbox">
        <div class="form-check">
          <input
              style="margin-bottom: 4px"
              v-model="showAllChecked"
              class="form-check-input"
              type="checkbox"
              id="checkAll"
              @change="checkAllChanged($event)"
          />
        </div>
      </th>
      <th scope="col" style="width: 20px" v-perm="'device.qrcode.bind'">
        <i
            class="ri-arrow-down-s-line"
            style="cursor: pointer"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            v-show="isShowTHstate"
        ></i>
        <div class="dropdown-menu dropdownmenu-info">
          <div
              class="form-check mb-2 ms-2"
              v-for="(state, i) in allStateCheck"
              :key="i"
          >
            <input
                class="form-check-input me-1"
                type="radio"
                name="flexRadioDefault"
                v-model="allState"
                :value="state.value"
                @change="allStateChange($event, state)"
            />
            <label class="form-check-label" for="flexRadioDefault">{{
                state.label
              }}</label>
          </div>
        </div>
      </th>
      <th
          scope="col"
          v-for="th in column"
          :key="th.dataIndex"
          v-perm="th.permCode"
          v-show="th.isShow"
      >
        <template v-if="th.title==this.$t('page.create-time')">
          {{ th.title }}
          <button tabindex="-1" :aria-label="sortTitle" :title="sortTitle" :class="['gridjs-sort', sortClass]" @click="createdTimeSort"></button>
        </template>
        <template v-else>
          {{ th.title }}
        </template>
      </th>
      <th>{{ this.$t('page.operation') }}</th>
    </tr>
    </thead>
    <tbody class="list">
    <tr v-for="(item, index) in showTableData" :key="index">
      <td scope="row" v-perm="'device.qrcode.bind'" v-if="showCheckbox">
        <div class="form-check">
          <input
              style="margin-bottom: 4px"
              class="form-check-input"
              v-model="item.checked"
              type="checkbox"
              name="chk_child"
              @change="singleChecked($event, item.event_id)"
          />
        </div>
      </td>
      <td scope="row" v-perm="'device.qrcode.bind'"></td>
      <td
          v-for="th in column"
          :key="th.dataIndex"
          scope="col"
          v-perm="th.permCode"
          v-show="th.isShow"
      >
        <b-link v-if="th.canView" @click.prevent="handleAction(item, 'view')">{{ item[th.dataIndex] || "-" }}</b-link>
        <b-link v-else-if="productType == 1 && th.dataIndex === 'root_sn'" @click.prevent="handleAction(item, 'view')">{{ item[th.dataIndex] || "-" }}</b-link>
        <b-link v-else-if="productType == 2 && th.dataIndex === 'group_sn'" @click.prevent="handleAction(item, 'view')">{{ item['root_sn'] || "-" }}</b-link>
        <!--  列表页面机组设备关联的泵头序列号显示        -->
        <template v-else-if="productType == 2 && th.dataIndex === 'root_sn'">
          <div
              class="root_sn_list"
              :id="`root_sn_list-${item.id}`"
              v-b-tooltip.hover
              :title="item.root_sn_list.length&&item.root_sn_list.join('<br/>')"
          >
            <div v-for="(sn, snIndex) in item.root_sn_list" :key="snIndex">
              {{ sn }}
            </div>
          </div>
        </template>
        <!-- 二维码绑定 -->
        <template v-else-if="th.dataIndex === 'is_qrcode_bind'&&(user&&user.user_type!=='customer')">
          <div class="dropdown" v-if="hasQRCodeBindPerm">
            <button :class="['btn btn-sm waves-effect waves-light dropdown-toggle', colorList[item[th.dataIndex]].btn]" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ qrcodeOptionsTxt(item[th.dataIndex]) }}
            </button>
            <div class="dropdown-menu">
              <a v-for="qrcode in qrcodeFilter(item[th.dataIndex])" :key="qrcode.value" class="dropdown-item" href="javascript:void(0);" @click="qrcodeBindHandle(item,qrcode)">{{ qrcode.label }}</a>
            </div>
          </div>
          <template v-else>
            <span :class="['badge', colorList[item[th.dataIndex]].badge]">{{ qrcodeOptionsTxt(item[th.dataIndex]) }}</span>
          </template>
        </template>
        <template v-else-if="th.dataIndex==='created_time'">{{ formatDatetime(item[th.dataIndex]) }}</template>
        <template v-else-if="th.dataIndex === '应用行业' || th.dataIndex === '设备状态'">{{ industryTxt(item,th.dataIndex) }}</template>
        <template v-else-if="th.dataIndex==='维保服务商'">{{ item.service_company_txt ||  '-' }}</template>
        <template v-else>{{ item[th.dataIndex] || "-" }}</template>
      </td>
      <td>
        <ul class="list-inline hstack gap-2 mb-0">
          <template v-for="(icon, iconIndex) in actionIcon" :key="iconIndex">
            <li
                class="list-inline-item"
                @click="handleAction(item, icon.type)"
                v-perm="icon.permCode"
            >
                <span :class="['d-inline-block', `text-${icon.textType}`]">
                  <i :class="['fs-16', icon.iconClass]"></i>
                </span>
            </li>
          </template>
        </ul>
      </td>
    </tr>
    <tr>
      <td colspan="100" class="text-center" v-if="showTableData.length === 0">
        {{ $t('base.no-data') }}
      </td>
    </tr>
    </tbody>
  </table>
  <!-- staticBackdrop Modal -->
  <b-modal
      v-model="showDelModal"
      hide-footer
      :title="title"
      header-class="mb-3 fs-16"
      body-class="text-center p-2 mb-2"
      centered
      size="md"
  >
    <div>
      <p class="fs-14 mb-2">
        <i style="color: #f06548; font-size: 16px;" class="ri-error-warning-line"></i>
        <span
            v-if="!delInfo.has_parent && !delInfo.has_children"
        >{{ this.$t('page.delete_all_data') }}</span
        >
        <span
            v-if="delInfo.has_parent && delInfo.has_children"
        >{{ this.$t('page.parent_child_node') }}</span
        >
        <span
            v-if="delInfo.has_parent && !delInfo.has_children"
        >{{ this.$t('page.parent_node') }}</span
        >
        <span
            v-if="!delInfo.has_parent && delInfo.has_children"
        >{{ this.$t('page.child_node') }}</span
        >
      </p>
    </div>
    <div class="modal-footer text-center p-2 justify-content-center">
      <div class="hstack gap-2 justify-content-center">
        <a
            href="javascript:void(0);"
            class="btn fw-medium btn-light"
            data-bs-dismiss="modal"
        >{{this.$t('base.cancel')}}</a
        >

        <a
            v-if="!delInfo.has_parent && !delInfo.has_children"
            href="javascript:void(0);"
            @click="deleteInstancesDetail"
            data-bs-dismiss="modal"
            class="btn btn-primary"
        >{{ this.$t('base.done')
          }}</a>
        <a
            v-if="delInfo.has_parent"
            href="javascript:void(0);"
            @click="noDeleteModelDetail('p')"
            data-bs-dismiss="modal"
            class="btn btn-primary"
        >{{ this.$t('page.edit_parent') }}</a
        >
        <a
            v-if="delInfo.has_children"
            href="javascript:void(0);"
            @click="noDeleteModelDetail('s')"
            data-bs-dismiss="modal"
            class="btn btn-primary"
        >{{ this.$t('page.edit_child') }}</a
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
import { deleteInstancesDetailId, postBindQRCode } from "@/service/index"
import {successMsg, alertError} from "@/helpers/swal";
import store from "@/state/store";
import { formatDatetime } from "@/helpers/common";
import i18n from "@/i18n";
export default {
  emits: ["update:singleData", "changeSort"],
  props: {
    singleData: Object,
    actionIcon: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
    refreshData: {
      type: Function,
      default: null
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    source: {
      type: String,
      default: "", // 来源：equipment-management:设备列表 equipment-detail-associated:设备详情关联列表
    },
    productType: {
      type: [String, Number],
      default: "", // 产品类型：1: 单体设备 2：机组设备
    },
    defaultSort: {
      type: Number,
      default: 0,
    },
    qrcodeOptions:{
      type:Array,
      default: () => {
        return [];
      },
    }
  },
  data() {
    return {
      showTableData: [],
      showDelModal: false,
      delInfo: {
        name: "",
      },
      showAllChecked: false,
      isShowTHstate: false,
      allStateCheck: [{ label: i18n.global.t('menu.equipment-management.NotBound'), value: false }, { label: this.$t('menu.equipment-management.Bound'), value: true }],
      allState: null,
      sort: null,
      //颜色
      colorList:{
        0:{btn:'btn-soft-primary',badge:'badge-soft-primary'},
        1:{btn:'btn-soft-success',badge:'badge-soft-success'},
        2:{btn:'btn-soft-danger',badge:'badge-soft-danger'},
      },
      //设备状态
      device_type:{
          在用: this.$t("在用"),
          备用: this.$t("备用"),
          报废: this.$t("报废"),
        },
    };
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    title() {
      return this.$t('page.work-order.device.delete') + (this.delInfo ? this.delInfo.name : "")
    },
    hasQRCodeBindPerm(){
      return store.getters['permission/isGuranted']("device.qrcode.bind");
    },
    sortTitle() {
      return this.sort === 1 || this.sort === null ? "Sort column ascending" : "Sort column descending";
    },
    sortClass() {
      return this.sort === null ? "gridjs-sort-neutral" : (this.sort === 1 ? "gridjs-sort-asc" : "gridjs-sort-desc");
    },
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.showTableData = newVal;
      },
      deep: true,
      immediate: true,
    },
    showTableData: {
      handler(newVal) {
        if (!newVal.length) return;
        this.isShowTHstate = newVal.some((item) => {
          return item.checked;
        });
      },
      deep: true,
      immediate: true,
    },
    defaultSort: {
      handler(val) {
        if (this.sort !== val) this.sort = val
      }
    }
  },
  methods: {
    //应用行业翻译
    industryTxt(attr,key){
        let  reslut = attr[key]
        if(key == '应用行业' && attr[key]){ 
            reslut = attr[key]?this.$t(`overview_dynamic.industy_dict['${attr[key]}']`):'-'
        }else{ //设备状态
            reslut = attr[key]?this.device_type[attr[key]]:'-'
        }
        
        return reslut;
    },
    qrcodeFilter(qrcode){
      let list = this.qrcodeOptions.filter(item => item.value != qrcode)
      return list;
    },
    qrcodeOptionsTxt(qrcode){
      let info = this.qrcodeOptions.find(item => item.value == qrcode)
      return info&&info.label || '-'
    },
    closeAll(){
      this.showAllChecked=false
    },
    formatDatetime,
    createdTimeSort(){
      if(this.sort == null){
        this.sort = 1
      }
      else {
        this.sort = -this.sort
      }

      this.$emit('changeSort', this.sort)
    },
    checkAllChanged() {
      this.$emit("checkAllChanged", this.showAllChecked);
    },
    allStateChange(ev, state) {
      let ele = ev.currentTarget.parentElement;
      if (ele && ele.parentNode && ele.parentNode.classList.contains("show")) {
        setTimeout(() => {
          ele.parentNode.classList.remove("show");
          this.allState = null;
          this.showAllChecked = false
        }, 200);
      }
      this.$emit("changeMoreStatus", state.value);
    },
    singleChecked(ev, id) {
      if (!ev.target.checked){
        this.showAllChecked = false;
      }
      this.$emit("singleChecked", id, ev.target.checked);
    },
    handleAction(event, iconType) {
      switch (iconType) {
        case "edit":
          this.pushDetailTab()
          this.$router.push({
            path: "/asset/form",
            query: {
              type: "edit",
              title: this.$t('page.work-order.device.edit'),
              // model_id: this.obj_model_id,
              instance_id: event.id,
              source: this.source,
            },
          });
          // this.$router.push(`/asset?asset_id=${event.id}&isto=edit`);
          break;
        case "view":
          this.pushDetailTab('view')
          this.$router.push({
            path: "/equipment-detail",
            query: {
              equip_id: event.id,
            },
          });
          break;
        case "delete":
          //todo :点击进入物实例详情页的删除弹窗
          this.delInfo = event
          this.showDelModal = true
          break;
      }
    },
    //删除子节点父节点跳转
    noDeleteModelDetail(type) {
      switch (type) {
        case "p":
          this.$router.push({
            path: "/asset/form",
            query: {
              type: "edit",
              title: this.$t('page.work-order.device.edit'),
              instance_id: this.delInfo.parent_id,
              layer_num: this.obj_layer_id,
            },
          });
          break;
        case "s":
          this.$router.push({
            path: "/asset/form",
            query: {
              type: "edit",
              title: this.$t('page.work-order.device.edit'),
              instance_id: this.delInfo.id,
              layer_num: this.obj_layer_id,
            },
          });
          break;
        default:
          break;
      }
    },
    deleteInstancesDetail() {
      let params = {
        id: this.delInfo.id,
      };
      deleteInstancesDetailId(params)
          .then(() => {
            successMsg(this.$t('base.delete_success'))
            this.refreshData()
          })
      // .catch((err) => {
      //   if (err.message.message) {
      //     alertError(err.message.message);
      //   }
      // });
    },
    /* 修改二维码 */ 
    qrcodeBindHandle(item,qrcode) {

      let params = {
        id: item.id,
        op: qrcode.value
      }
      postBindQRCode(params)
          .then((res) => {
            if (res && res.meta && res.meta.code == 200) {
              item.is_qrcode_bind = qrcode.value
              successMsg(this.$t('base.operate_success'))
            }
          })
          .catch((err) => {
            if (err.message.message) {
              alertError(err.message.message);
            }
          });
    },
    // 记录当前设备详情tab
    pushDetailTab(type) {
      let currentTab = localStorage.getItem('instanceDetailCurrentTab')
      if (!currentTab)
        return
      let tabHistory = JSON.parse(localStorage.getItem('instanceDetailTabHistory'))
      if (!tabHistory) {
        tabHistory = []
      }
      tabHistory.push(currentTab)
      if (type === 'view') {
        tabHistory.push('baseInfo')
      }
      localStorage.setItem('instanceDetailTabHistory', JSON.stringify(tabHistory))
      localStorage.removeItem('instanceDetailCurrentTab')
    },
  },
};
</script>
<style lang="scss">
.badge-open {
  color: #3577f1;
  background: rgba(53, 119, 241, 0.1);
}
.badge-handling {
  color: #50c3e6;
  background: rgba(80, 195, 230, 0.1);
}
.badge-waitconfirm {
  color: #865ce2;
  background: rgba(134, 92, 226, 0.1);
}
.badge-closed {
  color: #212529;
  background: rgba(236, 156, 98, 0.1);
}
.badge-released {
  color: #13c56b;
  background: rgba(19, 197, 107, 0.1);
}
.badge-solved {
  color: #6691e7;
  background: rgba(64, 81, 137, 0.1);
}
.root_sn_list {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
button.gridjs-sort{
  float: none !important;
  height: 18px !important;
}
</style>
